export default (sliderSelector, animationList = {}) => {
	var config = {
		start: {
			dataName: 'animate'
		},
		animationList
	}

	var asElement = function (element, animation) {
		var self = {}
		var startElement = animation.getStartStyle()
		var finishElement = animation.getFinishStyle()

		self.init = function () {
			self.startStyle()
			self.addScrollEvent()
			self.addRetryFunction()
			self.startAnimate()
		}

		self.startStyle = function () {
			startElement.forEach(function (o) {
				element.style[o.element] = o.value
			})
		}

		self.animate = function () {
			finishElement.forEach(function (o) {
				element.style[o.element] = o.value
			})
		}

		self.startAnimate = function () {
			setTimeout(function () {
				self.animate()
			}, 400)
		}

		self.position = function () {
			return element.getBoundingClientRect().top / window.innerHeight
		}

		self.addScrollEvent = function () {
			window.addEventListener('scroll', throttle(scrollFuncition, 200))
		}

		var scrollFuncition = function () {
			if (self.position() < config.start.ratio) {
				self.animate()
			}
		}

		var throttle = function (callback, time) {
			var wait = false
			return function () {
				if (!wait) {
					setTimeout(function () {
						callback()
						wait = false
					}, time)
				}
				wait = true
			}
		}

		self.addRetryFunction = function () {
			element.asRetry = function () {
				self.startStyle()
				setTimeout(function () {
					self.animate()
				}, 0)
			}
		}

		self.init()

		return self
	}

	var animation = function (data) {
		var self = {}
		var startStyle = []
		var finishStyle = []

		self.init = function () {
			data = data.split(';')
			var first = data[0]
			if (config.animationList[first]) {
				data.shift()
				data = config.animationList[first].split(';').concat(data)
			}
			data.forEach(function (e) {
				if (e.indexOf(':') > -1) {
					createStartStyle(e)
					createFinishStyle(e)
				}
			})
		}

		var createStartStyle = function (e) {
			var styleS = {}

			styleS['element'] = e.split(':')[0].replace(/\s*/gi, '')
			styleS['value'] = e.split(':')[1].split('->')[0]

			if (styleS.element !== undefined && styleS.value !== undefined) {
				startStyle.push(styleS)
			}
		}

		var createFinishStyle = function (e) {
			var styleF = {}

			styleF['element'] = e.split(':')[0].replace(/\s*/gi, '')
			styleF['value'] = e.split(':')[1].split('->')[1]

			if (styleF.element !== undefined && styleF.value !== undefined) {
				finishStyle.push(styleF)
			}
		}

		self.getStartStyle = function () {
			return startStyle
		}

		self.getFinishStyle = function () {
			return finishStyle
		}

		self.init()

		return self
	}
	const slider = document.querySelector(sliderSelector)
	if (!slider) return
	slider.addEventListener('slide.bs.carousel', ({
		relatedTarget
	}) => {
		const elements = relatedTarget.querySelectorAll('[data-' + config.start.dataName + ']');
		[...elements].forEach(element => {
			const data = element.dataset[config.start.dataName]
			asElement(element, animation(data))
		})
	})
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/amazingScrollSlider.js